import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext({ theme: 'light', toggleTheme: () => {}, colorTheme: 'blue', setColorTheme: () => {} });

export const useTheme = () => useContext(ThemeContext);

// Single source of truth for the accent-color options — shared by the
// header's quick "My Theme" picker and the full Admin Settings page.
export const colorOptions = [
  { id: 'blue',    color: '#3b82f6', label: 'Ocean Blue',   desc: 'Classic professional' },
  { id: 'indigo',  color: '#4f46e5', label: 'Indigo',       desc: 'Deep blue-purple' },
  { id: 'violet',  color: '#8b5cf6', label: 'Violet',       desc: 'Elegant purple' },
  { id: 'fuchsia', color: '#c026d3', label: 'Fuchsia',      desc: 'Bold magenta pink' },
  { id: 'rose',    color: '#e11d48', label: 'Rose Red',     desc: 'Vivid rose red' },
  { id: 'amber',   color: '#d97706', label: 'Amber',        desc: 'Warm golden orange' },
  { id: 'lime',    color: '#65a30d', label: 'Lime Green',   desc: 'Fresh lime green' },
  { id: 'emerald', color: '#059669', label: 'Emerald',      desc: 'Rich forest green' },
  { id: 'teal',    color: '#0d9488', label: 'Teal',         desc: 'Cool teal cyan' },
  { id: 'slate',   color: '#475569', label: 'Slate',        desc: 'Neutral minimal' },
];

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    try {
      return localStorage.getItem('primeclean-theme') || 'light';
    } catch {
      return 'light';
    }
  });

  const [colorTheme, setColorTheme] = useState(() => {
    try {
      return localStorage.getItem('primeclean-color-theme') || 'blue';
    } catch {
      return 'blue';
    }
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    document.documentElement.setAttribute('data-color', colorTheme);
    try { 
      localStorage.setItem('primeclean-theme', theme); 
      localStorage.setItem('primeclean-color-theme', colorTheme);
    } catch {}
  }, [theme, colorTheme]);

  const toggleTheme = () => setTheme(prev => prev === 'light' ? 'dark' : 'light');

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, colorTheme, setColorTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext;
